<template>
  <div id="app">
    <div class="shop-header-margin shop-header-element-ui-less"
      :class="'shop-header-element-ui-less-' + data_info.nav_color">
      <div class="top-one">
        <head_dianpu></head_dianpu>
      </div>
      <div class="top-two hidden-sm-and-down">
        <el-row>
          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
            <div>
              <el-row :gutter="20">
                <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                  <img src="../../../assets/home/logo.png" style="width: 100%; height: 100%" />
                </el-col>
                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                  <div class="top-two_text">
                    <span style="float: left">{{ data_info.shop_name }}</span>
                    <div class="follow" style="color: #c60000; border: 1px solid #c60000">
                      <span v-if="data_info.auth_info.type == 1">个人</span>
                      <span v-if="data_info.auth_info.type == 2">企业</span>
                      <span v-if="data_info.auth_info.type == 3">企业</span>
                    </div>
                    <div class="follow" :class="data_info.nav_color + '_follow'" @click="shouce1()">
                      {{ xiontai }}
                    </div>
                  </div>
                  <div class="label">
                    产品/技能/服务：
                    <el-tag type="info" style="margin-right: 5px" size="mini" v-for="(item, index) in data_info.skill"
                      :key="index">{{ item.tag_value }}
                    </el-tag>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
            <div>
              <el-input size="small " placeholder="请输入内容" v-model="input3" class="input-with-select">
                <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                  <el-option v-if="data_info.auth_info.type !== 1" label="在线商品" value=""></el-option>
                  <el-option label="在线服务" value="#/shops/service/"></el-option>
                  <el-option label="成功案例" value="#/shops/case/"></el-option>
                  <el-option label="仪才秀" value="#/shops/video/"></el-option>
                  <el-option label="小星点灯" value="#/shops/light/"></el-option>
                  <el-option label="应用方案" value="#/shops/programme/"></el-option>
                  <el-option label="行业标准" value="#/shops/standard/"></el-option>
                </el-select>
                <el-button slot="append" @click="shijian">搜索</el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="top-three hidden-sm-and-down" :class="data_info.nav_color">
        <div class="hidden-sm-and-down three_pc">
          <a :href="'#/shops/index/' + list.shop_id">
            <div class="kuai" :class="
              $route.path === '/shops/index/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              首页
            </div>
          </a>
          <a :href="'#/shops/commodity/' + list.shop_id">
            <el-dropdown class="kuai1" :class="
              $route.path == '/shops/commodity/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              <span class="el-dropdown-link">在线商品</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a :href="'#/shops/commodity/' + list.shop_id" style="text-decoration:none">
                  <el-dropdown-item v-for="(shangpin, index) in shangpin_list" :key="index">{{ shangpin.label }}
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
            
          </a>
          <a :href="'#/shops/service/' + list.shop_id">
            <el-dropdown class="kuai" :class="
              $route.path == '/shops/service/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              <span class="el-dropdown-link">在线服务</span>

              <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                <a :href="'#/shops/service/' + list.shop_id" style="text-decoration:none">
                  <el-dropdown-item v-for="(fuwu, index) in fuwu_list" :key="index">{{ fuwu.label }}
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </a>
          <a :href="'#/shops/case/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/case/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              成功案例
            </div>
          </a>
          <a :href="'#/shops/video/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/video/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              仪才秀
            </div>
          </a>
          <a :href="'#/shops/light/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/light/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              小星点灯
            </div>
          </a>
          <a :href="'#/shops/programme/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/programme/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              应用方案
            </div>
          </a>
          <a :href="'#/shops/standard/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/standard/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              行业标准
            </div>
          </a>
          <a :href="'#/shops/companyData/' + list.shop_id">
            <div class="kuai" :class="
              $route.path == '/shops/companyData/' + list.shop_id
                ? data_info.nav_color + '_new'
                : ''
            ">
              公司资料
            </div>
          </a>
        </div>
      </div>
      <el-container class="ciyemian_yibei_qiangzhi_buxudong flextext">
        <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no" />
        <el-main>
          <div class="contain">
            <div class="small-title">{{ list.title }}</div>
            <el-row :gutter="30">
              <el-col :xs="24" :sm="24" :md="9">
                <div class="shop_list">
                  <img v-if="list.cover" style="height: 460px; width: 460px" :src="url + '/storage/' + list.cover"
                    fit="cover" />
                  <img v-else class="weijiazai_img_qiangzhi"
                    src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 360px"
                    width="250px" />
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="15">
                <div class="shop-span">
                  <ul style="position: absolute">
                    <li v-if="list.jiaofu == 2">现货</li>
                    <li v-if="list.jiaofu == 1">
                      订货
                      <div class="jiaofu_time">
                        {{ list.jiaofu_date + "天" }}
                      </div>
                    </li>
                    <li v-if="list.is_fittings == 1" style="position: absolute; margin-left: 80px">
                      配件
                      <span class="jiaofu_time" style="width: 200%">主体：{{ list.fittings }}</span>
                    </li>
                    <li v-if="list.is_fittings == 0" style="position: absolute; margin-left: 80px">
                      整机
                    </li>
                  </ul>
                  <div class="xin_jiu" v-if="list.is_new == 1">全新</div>
                  <div class="xin_jiu" v-if="list.is_new == 0">二手</div>
                </div>
                <div style="margin-bottom: 30px; margin-left: 40px">
                  <div>
                    <span class="prices" v-if="list.cash == 0.0">价格 <span class="moneys">¥</span><span
                        class="value">面议</span>
                    </span>
                    <span class="prices" v-else>价格 <span class="moneys">￥</span><span class="value">{{ list.cash
                    }}</span>
                    </span>
                  </div>
                  <div class="guige_tou" v-if="list.attachment[0]">
                    <span style="margin-right: 65px; float: left">附件</span>
                    <a :href="url + '/storage/' + list.attachment[0].url" target="“_blank”"
                      style="display: block; float: left; margin-left: 35px">
                      <el-link type="primary" style="
                          color: #4e6ef2;
                          font-size: 14px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                        ">
                        {{ list.attachment[0].name }}
                      </el-link>
                    </a>
                  </div>
                  <div class="guige_tou" v-if="list.cert_file[0]">
                    <span style="margin-right: 65px; float: left">必要资质</span>
                    <a :href="url + '/storage/' + list.cert_file[0].url" target="“_blank”"
                      style="display: block; float: left">
                      <el-link type="primary" style="
                          color: #4e6ef2;
                          font-size: 14px;
                          font-family: Source Han Sans CN;
                          font-weight: bold;
                        ">
                        {{ list.cert_file[0].name }}
                      </el-link>
                    </a>
                  </div>
                  <el-divider class="hr"></el-divider>
                  <div class="guige_tou">
                    <span style="margin-right: 65px; float: left">应用行业</span>
                    <div style="
                        position: absolute;
                        margin-left: 140px;
                        width: 410px;
                      ">
                      <span v-for="(itenn, indee) in aac_job" :key="indee">
                        <span v-for="(itte, innd) in itenn.aac_arr_path" :key="innd">
                          <span v-if="itte[1]" style="
                              color: #4e6ef2;
                              font-size: 14px;
                              font-family: Source Han Sans CN;
                              font-weight: bold;
                            ">
                            <template v-if="innd == 0">
                              {{ itte[0].title + "/" + itte[1].title }}
                            </template>
                            <template v-else>
                              {{ "、" + itte[1].title }}{{ message }}
                            </template>
                          </span>
                          <span v-else style="
                              color: #4e6ef2;
                              font-size: 14px;
                              font-family: Source Han Sans CN;
                              font-weight: bold;
                            ">
                            {{ itte[0].title }}{{ message }}
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <el-divider class="hr"></el-divider>
                  <div class="guige_tou">
                    <span style="margin-right: 65px">应用场景</span>
                    <div style="margin-left: 140px; margin-top: -40px">
                      <div v-if="zz == 1" style="width: 450px">
                        <span v-for="(item, index) in scene_li" :key="index" style="
                            color: #4e6ef2;
                            font-size: 14px;
                            font-family: Source Han Sans CN;
                            width: 100px;
                            font-weight: bold;
                          ">
                          <div style="margin-top: 20px">
                            {{ item.slice(0, 30) }}{{ message }}
                          </div>
                        </span>
                        <i class="el-icon-arrow-down" style="
                            position: absolute;
                            margin: -40px 0px 0px 500px;
                            font-size: 15px;
                            font-weight: bold;
                            color: #0c73db;
                          " @click="dianji">
                        </i>
                      </div>
                      <div v-if="zz == 2" style="width: 450px">
                        <span v-for="(item, index) in scene_li" :key="index" style="
                            color: #4e6ef2;
                            font-size: 14px;
                            font-family: Source Han Sans CN;
                            width: 100px;
                            font-weight: bold;
                          ">
                          <div style="margin-top: 20px">
                            {{ item }}{{ message }}
                          </div>
                        </span>
                        <i class="el-icon-arrow-up" style="
                            position: absolute;
                            margin: -40px 0px 0px 500px;
                            font-size: 15px;
                            font-weight: bold;
                            color: #0c73db;
                          " @click="dianji1">
                        </i>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <el-divider class="hr"></el-divider>    -->
                <!--  立即购买-->
                <div>
                  <!-- <span style="margin-top: 50px;height: auto">
                                        <span class="prices-one">
                                            <span class="jibuqi">
                                                <span style="margin-left:3px; width:100px" class="moneys-num_a">
                                                    选择
                                                </span>
                                                <span style="margin-left:36px; width:100px;" class="moneys-num_a">
                                                    {{list_guige[list_guige.length-1].specification}}
                                                </span>
                                                <span style="width: 100px;" class="moneys-num_a">
                                                    {{ list_guige[list_guige.length-1].cash * list_guige[list_guige.length-1].sum }}元
                                                </span>
                                                <el-input-number size="mini"
                                                                 v-model="list_guige[list_guige.length-1].sum"
                                                                 @change="handleChange2" :min="0"
                                                                 :max="10" label="" class="">
                                                </el-input-number>
                                            </span>
                                        </span>
                                    </span> -->
                </div>
                <el-divider class="hr"></el-divider>
                <!--按钮立即购买 -->
                <span class="buy">
                  <el-button @click="goumai_sj(list.id)" class="buy-button" type="primary">立即购买</el-button>
                </span>
                <span class="buy">
                  <el-button class="buy-button" type="primary" v-if="status" @click="shouce(list.id)">
                    {{ status }}
                  </el-button>
                </span>
              </el-col>
            </el-row>


            <div style="margin-bottom: 40px; height: 400px; width: 100%">

              <div class="aaa hidden-sm-and-down">
                <div class="xinxi" style="width: 230px; height: 272px">
                  <div style="
                      background-color: #4e6ef2;
                      height: 45px;
                      width: 229px;
                      border-radius: 5px 5px 0px 0px;
                    ">
                    <i class="el-icon-service"></i>
                    <span class="kefuzhongxin">客服中心</span>
                  </div>
                  <div>
                    <div class="center_title flex">在线联系
                      <div class="yixiaoxing">
                        <img src="../../../assets/home/yixiaoxing1.png" alt="" class="image" @click="chat_list" />
                      </div>
                    </div>

                    <p class="center_title">联系电话</p>
                    <p class="center_mintitle">{{ inform.mobile }}</p>
                    <p class="center_title">厂家地址</p>
                    <p class="center_mintitle">{{ sheng }}{{ shi }}{{ qv }}</p>
                  </div>
                </div>
              </div>


              
              <div class="bottom_right_background">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="详情描述" name="first">
                    <div style="
                        border-style: none none none solid;
                        margin-top: 32px;
                        color: #4e6ef2;
                      ">
                      <span style="
                          padding: 10px;
                          color: #666666;
                          font-size: 14px;
                          font-family: Source Han Sans CN;
                        ">
                        原理示意图/结构流程图
                      </span>
                    </div>
                    <div class="image_css">
                      <img class="image_css1" :src="url + '/storage/' + list.flowchart" />
                    </div>
                    <div v-for="(item, index) in list_flowchart.length" :key="index">
                      <div class="min-title-content">
                        <div class="mimi_title">
                          <div style="
                              margin-left: 17px;
                              line-height: 38px;
                              position: absolute;
                              font-size: 14px;
                              font-family: Source Han Sans CN;
                              color: #666666;
                            ">
                            {{ item }}.{{ list_flowchart[item - 1].title }}
                          </div>
                        </div>
                      </div>
                      <div class="top_desc">
                        <span>
                          {{ list_flowchart[item - 1].description }}
                        </span>
                      </div>
                      <div class="image_css">
                        <img v-if="list_flowchart[item - 1].chart" class="image_css1"
                          :src="list_flowchart[item - 1].chart" />
                        <img v-else class="image_css1" src="../../../assets/wenzhangfengmian.png" />
                      </div>
                      <el-row :gutter="170">
                        <el-col :span="5" v-for="(item2, index2) in list_flowchart[item - 1]
                        .children.length" :key="index2">
                          <div v-if="
                            list_flowchart[item - 1].children[item2 - 1].image
                          ">
                            <div class="col_content" v-if="
                              list_flowchart[item - 1].children.length > 1
                            ">
                              <img v-if="
                                list_flowchart[item - 1].children[item2 - 1]
                                  .image
                              " class="image_min" :src="
                                url +
                                '/storage/' +
                                list_flowchart[item - 1].children[item2 - 1]
                                  .image
                              "/>
                              <img v-else class="image_min" src="../../../assets/wenzhangfengmian.png" />
                              <div class="img_title">
                                {{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .title
                                }}
                              </div>
                              <div style="
                                  margin-left: 21px;
                                  font-size: 14px;
                                  margin-right: 10px;
                                ">
                                {{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .description
                                }}
                              </div>
                              <div style="
                                  margin-left: 21px;
                                  margin-top: 40px;
                                  font-size: 18px;
                                  font-family: Source Han Sans CN;
                                  color: #e02727;
                                  font-weight: bolder;
                                ">
                                ￥{{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .price
                                }}/PK11
                              </div>
                              <div class="gl_more">
                                <el-popover placement="right" width="400" trigger="click">
                                  <span slot="reference">
                                    更多
                                    <i class="el-icon-d-arrow-right"></i>
                                  </span>
                                  <div class="gl_more1">
                                    <!-- 关联仪才秀-->
                                    <div style="margin-bottom: 20px" v-if="
                                      list_flowchart[item - 1].children[
                                        item2 - 1
                                      ].video
                                    ">
                                      <span class="gl_ycx">关联仪才秀:</span>
                                      <a target="_blank" :href="
                                        '#/college/video/' +
                                        list_flowchart[item - 1].children[
                                          item2 - 1
                                        ].video.id
                                      ">
                                        <span>
                                          {{
                                              list_flowchart[item - 1].children[
                                                item2 - 1
                                              ].video.title
                                          }}
                                        </span>
                                      </a>
                                    </div>
                                    <!-- 关联小星点灯-->
                                    <div v-if="
                                      list_flowchart[item - 1].children[
                                        item2 - 1
                                      ].star_light
                                    ">
                                      <span class="gl_ycx">关联小星点灯:</span>
                                      <a target="_blank" :href="
                                        '#/dianpu_ligs/' +
                                        list_flowchart[item - 1].children[
                                          item2 - 1
                                        ].star_light.id
                                      ">
                                        <span>
                                          {{
                                              list_flowchart[item - 1].children[
                                                item2 - 1
                                              ].star_light.title
                                          }}
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </el-popover>
                              </div>
                            </div>
                          </div>
                          <div v-if="
                            list_flowchart[item - 1].children[item2 - 1].image
                          ">
                            <div class="col_content1" v-if="
                              list_flowchart[item - 1].children.length == 1
                            ">
                              <img v-if="
                                list_flowchart[item - 1].children[item2 - 1]
                                  .image
                              " class="image_min1" :src="
                                  url +
                                  '/storage/' +
                                  list_flowchart[item - 1].children[item2 - 1]
                                    .image
                               " />
                              <img v-else class="image_min1" src="../../../assets/wenzhangfengmian.png" />
                              <span class="img_title1">
                                {{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .title
                                }}
                              </span>
                              <span class="img_desc1">
                                {{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .description
                                }}
                              </span>
                              <span class="img_price1">
                                ￥{{
                                    list_flowchart[item - 1].children[item2 - 1]
                                      .price
                                }}/PK22
                              </span>
                              <div class="more-icon">
                                <el-popover placement="right" width="400" trigger="click">
                                  <span slot="reference">
                                    更多
                                    <i class="el-icon-d-arrow-right"></i>
                                  </span>
                                  <div class="gl_more1">
                                    <!-- 关联仪才秀-->
                                    <div style="margin-bottom: 20px" v-if="
                                      list_flowchart[item - 1].children[
                                        item2 - 1
                                      ].video
                                    ">
                                      <span class="gl_ycx">关联仪才秀:</span>
                                      <a target="_blank" :href="
                                        '#/college/video/' +
                                        list_flowchart[item - 1].children[
                                          item2 - 1
                                        ].video.id
                                      ">
                                        <span>
                                          {{
                                              list_flowchart[item - 1].children[
                                                item2 - 1
                                              ].video.title
                                          }}
                                        </span>
                                      </a>
                                    </div>
                                    <!-- 关联小星点灯-->
                                    <div v-if="
                                      list_flowchart[item - 1].children[
                                        item2 - 1
                                      ].star_light
                                    ">
                                      <span class="gl_ycx">关联小星点灯:</span>
                                      <a target="_blank" :href="
                                        '#/dianpu_ligs/' +
                                        list_flowchart[item - 1].children[
                                          item2 - 1
                                        ].star_light.id
                                      ">
                                        <span>
                                          {{
                                              list_flowchart[item - 1].children[
                                                item2 - 1
                                              ].star_light.title
                                          }}
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </el-popover>
                              </div>
                            </div>
                            <div style="width: 943px" v-if="
                              list_flowchart[item - 1].children.length == 1
                            ">
                              <el-row :gutter="150">
                                <el-col :span="5" v-for="(item3, index3) in list_flowchart[
                                  item - 1
                                ].children[item2 - 1].children.length" :key="index3">
                                  <div class="col_content" v-if="
                                    list_flowchart[item - 1].children[
                                      item2 - 1
                                    ].children[item3 - 1].image
                                  ">
                                    <img v-if="
                                      list_flowchart[item - 1].children[
                                        item2 - 1
                                      ].children[item3 - 1].image
                                    " class="image_min" :src="
                                        url +
                                        '/storage/' +
                                        list_flowchart[item - 1].children[
                                          item2 - 1
                                        ].children[item3 - 1].image
                                      " />
                                    <img v-else class="image_min" src="../../../assets/wenzhangfengmian.png" />
                                    <div class="img_title">
                                      {{
                                          list_flowchart[item - 1].children[
                                            item2 - 1
                                          ].children[item3 - 1].title
                                      }}
                                    </div>
                                    <div style="
                                        margin-left: 21px;
                                        font-size: 14px;
                                        width: 180px;
                                        margin-right: 10px;
                                      ">
                                      {{
                                          list_flowchart[item - 1].children[
                                            item2 - 1
                                          ].children[item3 - 1].description
                                      }}
                                    </div>
                                    <div style="
                                        margin-left: 21px;
                                        margin-top: 40px;
                                        font-size: 18px;
                                        font-family: Source Han Sans CN;
                                        color: #e02727;
                                        font-weight: bolder;
                                        width: 180px;
                                      ">
                                      ￥{{
                                          list_flowchart[item - 1].children[
                                            item2 - 1
                                          ].children[item3 - 1].price
                                      }}/PK33
                                    </div>
                                    <div class="gl_more">
                                      <el-popover placement="right" width="400" trigger="click">
                                        <span slot="reference">
                                          更多
                                          <i class="el-icon-d-arrow-right"></i>
                                        </span>
                                        <div class="gl_more1">
                                          <!-- 关联仪才秀-->
                                          <div style="margin-bottom: 20px" v-if="
                                            list_flowchart[item - 1].children[
                                              item2 - 1
                                            ].children[item3 - 1].video
                                          ">
                                            <span class="gl_ycx">关联仪才秀:</span>
                                            <a target="_blank" :href="
                                              '#/college/video/' +
                                              list_flowchart[item - 1]
                                                .children[item2 - 1].children[
                                                item3 - 1
                                              ].video.id
                                            ">
                                              <span>
                                                {{
                                                    list_flowchart[item - 1]
                                                      .children[item2 - 1]
                                                      .children[item3 - 1].video
                                                      .title
                                                }}
                                              </span>
                                            </a>
                                          </div>
                                          <!-- 关联小星点灯-->
                                          <div v-if="
                                            list_flowchart[item - 1].children[
                                              item2 - 1
                                            ].children[item3 - 1].star_light
                                          ">
                                            <span class="gl_ycx">关联小星点灯:</span>
                                            <a target="_blank" :href="
                                              '#/dianpu_ligs/' +
                                              list_flowchart[item - 1]
                                                .children[item2 - 1].children[
                                                item3 - 1
                                              ].star_light.id
                                            ">
                                              <span>
                                                {{
                                                    list_flowchart[item - 1]
                                                      .children[item2 - 1]
                                                      .children[item3 - 1]
                                                      .star_light.title
                                                }}
                                              </span>
                                            </a>
                                          </div>
                                        </div>
                                      </el-popover>
                                    </div>
                                  </div>
                                </el-col>
                              </el-row>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div>
                      <div class="min-title-content">
                        <div class="mimi_title">
                          <div style="
                              margin-left: 17px;
                              line-height: 38px;
                              position: absolute;
                            ">
                            选型指南
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="kehu_xuyao">1、客户需提供的参考信息：</div>
                        <div class="kehu_content">
                          <span style="padding: 10px">
                            {{ list.extra ? list.extra.guide_xinxi : "" }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div class="kehu_xuyao">2、产品关键性能指标：</div>
                        <div class="kehu_content">
                          <span style="padding: 10px">
                            {{ list.extra ? list.extra.guide_zhibiao : "" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="案例解析" name="third" style="background-color: white">
                    <div class="xiangqing_background1"></div>
                    <div style="padding: 10px 0px 10px 20px">
                      <a v-if="list.list_cases[0]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[0].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[0].title"></div>
                      </a>
                      <a style="position: relative" v-if="list.list_cases[1]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[1].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[1].title"></div>
                      </a>
                      <a v-if="list.list_cases[2]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[2].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[2].title"></div>
                      </a>
                      <a v-if="list.list_cases[3]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[3].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[3].title"></div>
                      </a>
                      <a v-if="list.list_cases[4]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[4].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[4].title"></div>
                      </a>
                      <a v-if="list.list_cases[5]" v-bind:href="
                        '#/dianpu_casedetails/' + list.list_cases[5].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_cases[5].title"></div>
                      </a>
                    </div>
                    <div class="xiangqing_background1"></div>
                  </el-tab-pane>
                  <el-tab-pane label="小星点灯" name="fourth" style="background-color: white">
                    <div class="xiangqing_background1"></div>
                    <div style="padding: 10px 0px 10px 20px">
                      <a v-if="list.list_light[0]" v-bind:href="'#/dianpu_ligs/' + list.list_light[0].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[0].title"></div>
                      </a>
                      <a v-if="list.list_light[1]" v-bind:href="'#/dianpu_ligs/' + list.list_light[1].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[1].title"></div>
                      </a>
                      <a v-if="list.list_light[2]" v-bind:href="'#/dianpu_ligs/' + list.list_light[2].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[2].title"></div>
                      </a>
                      <a v-if="list.list_light[3]" v-bind:href="'#/dianpu_ligs/' + list.list_light[3].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[3].title"></div>
                      </a>
                      <a v-if="list.list_light[4]" v-bind:href="'#/dianpu_ligs/' + list.list_light[4].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[4].title"></div>
                      </a>
                      <a v-if="list.list_light[5]" v-bind:href="'#/dianpu_ligs/' + list.list_light[5].id">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_light[5].title"></div>
                      </a>
                    </div>
                    <div class="xiangqing_background1"></div>
                  </el-tab-pane>
                  <el-tab-pane label="应用方案" name="fifth" style="background-color: white">
                    <div class="xiangqing_background1"></div>
                    <div style="padding: 10px 0px 10px 20px">
                      <a v-if="list.list_applicationProgram[0]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[0].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[0].title"></div>
                      </a>
                      <a v-if="list.list_applicationProgram[1]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[1].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[1].title"></div>
                      </a>
                      <a v-if="list.list_applicationProgram[2]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[2].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[2].title"></div>
                      </a>
                      <a v-if="list.list_applicationProgram[3]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[3].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[3].title"></div>
                      </a>
                      <a v-if="list.list_applicationProgram[4]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[4].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[4].title"></div>
                      </a>
                      <a v-if="list.list_applicationProgram[5]" v-bind:href="
                        '#/college/programme/' +
                        list.list_applicationProgram[5].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu"
                          v-html="list.list_applicationProgram[5].title"></div>
                      </a>
                    </div>
                    <div class="xiangqing_background1"></div>
                  </el-tab-pane>
                  <el-tab-pane label="行业标准" name="sixth" style="background-color: white">
                    <div class="xiangqing_background1"></div>
                    <div style="padding: 10px 0px 10px 20px">
                      <a v-if="list.list_norm[0]" v-bind:href="
                        '#/college/standard/' + list.list_norm[0].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[0].title">
                        </div>
                      </a>
                      <a v-if="list.list_norm[1]" v-bind:href="
                        '#/college/standard/' + list.list_norm[1].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[1].title">
                        </div>
                      </a>
                      <a v-if="list.list_norm[2]" v-bind:href="
                        '#/college/standard/' + list.list_norm[2].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[2].title">
                        </div>
                      </a>
                      <a v-if="list.list_norm[3]" v-bind:href="
                        '#/college/standard/' + list.list_norm[3].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[3].title">
                        </div>
                      </a>
                      <a v-if="list.list_norm[4]" v-bind:href="
                        '#/college/standard/' + list.list_norm[4].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[4].title">
                        </div>
                      </a>
                      <a v-if="list.list_norm[5]" v-bind:href="
                        '#/college/standard/' + list.list_norm[5].id
                      ">
                        <div style="word-break: break-all" class="bottom_titlemiaoshu" v-html="list.list_norm[5].title">
                        </div>
                      </a>
                    </div>
                    <div class="xiangqing_background1"></div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </el-main>
        <new_footer></new_footer>
      </el-container>
    </div>
  </div>
</template>
<script>
import { CodeToText } from "element-china-area-data";
import head from "../../common/head";
import new_footer from "../../common/new_footer";

export default {
  name: "dianpu_new",
  data: function () {
    return {
      zz: 1,
      favorite: false,
      is_open: {
        sousuo: 1,
        lanmu: 1,
      },
      dat_info: "",
      value: 5,
      status: "",
      aa: 1,
      activeName: "first",
      list: "",
      input3: "",
      list_guige: [
        {
          estimate: "",
          goods_id: "",
          id: "",
          price: "",
          cash: "",
          specification: "",
          sum: 0,
        },
      ],
      url: "",
      select: "在线服务",
      data_info: "",
      num: ["", "", ""],
      information: "",
      shop_id:'',
      inform: "",
      sheng: "",
      shi: "",
      qv: "",
      anli: [],
      diandeng: [],
      fangan: [],
      biaozhun: [],
      yingyong_hy: [],
      yingyong_title: [],
      xiontai: "",
      config: {
        email: "",
        phone: "",
      },
      shangpin_list: '',
      fuwu_list: '',
      data_list: [],
      data_uid: "",
      list_uid: "",
      inform_uid: "",
      inform_name: "",
      scene_li: [], //场景举例
      list_flowchart: [],
      message: "\xa0\xa0\xa0\xa0\xa0",
      yingyong_list: [],
      aac_job: [], //应用行业
      jaac_job: [
        {
          aac_arr_path: [
            [
              {
                title: "垃圾",
              },
              {
                title: "垃圾1",
              },
            ],
            [
              {
                title: "垃圾",
              },
              {
                title: "垃圾2",
              },
            ],
          ],
        },
      ],
    };
  },
  components: {
    head_dianpu: head,
    new_footer: new_footer,
  },
  methods: {
    chat_list() {
      if (this.data_uid != "") {
        window.location.href =
          "#/chat_new/" + this.data_uid + "?uid=" + this.inform_uid;
      } else {
        window.location.href = "/user.html";
      }
    },
    init() {
      this.get_uidlist();
      this.information = this.$store.state.information;
      this.url = window.config.api_url;
      this.list_data();
      this.zhuangtai();
      this.guanzhu();
      this.getConfig();
      this.hangyeyingyong();
    },
    //行业应用api
    hangyeyingyong() {
      let t = this;
      let url = window.config.api_url + "/college/subject/tree?deep=1";
      t.axios.get(url).then((res) => {
        t.yingyong_list = res.data;
      });
    },
    // 导航
    Changeshuju() {
      this.$store.commit("Changestate");
    },
    xiala(aa) {
      console.log(aa);
    },
    getConfig: function () {
      let t = this;
      if (!this.config.email || !this.config.phone) {
        let url = window.config.api_url + "/user/config/site";
        this.axios.get(url).then((res) => {
          t.config.email = res.data.site.email;
          t.config.phone = res.data.site["service-phone"];
        });
      }
    },
    guanzhu() {
      let t = this;
      let id = localStorage.getItem("token");
      let url =
        window.config.api_url +
        "/user/shop/focus/check/" +//返回101
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        t.xiontai = res.data.focus == 1 ? "已关注" : "关注";
      });
    },
    shouce1() {
      let t = this;
      let id = localStorage.getItem("uid");
      let formData = new FormData();
      formData.append("token", id);
      formData.append("shop_id", this.$route.params.id);
      if (t.xiontai == "关注") {
        let url = window.config.api_url + "/user/shop/focus";
        t.axios.post(url, formData).then((res) => {
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "已关注";
      } else {
        let url1 = window.config.api_url + "/user/shop/unfocus";
        t.axios.post(url1, formData).then((res) => {
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            this.$router.go(0);
          }
          if (res.data.status != 0) {
            t.open3(res.data.description);
          }
        });
        this.xiontai = "关注";
      }
    },
    shijian() {
      let t = this;
      if (t.input3) {
        t.$store.commit("shopsSearchValue", t.input3);
      }
      window.location = t.select + this.list.shop_id;
    },

    sousuo_xuanxiang(e) {
      this.is_open.sousuo = e;
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    zhuangtai() {
      let t = this;
      let id = localStorage.getItem("token");
      let url =
        window.config.api_url +
        "/user/goods/focus/check/" +//返回101
        t.$route.params.id +
        "?token=" +
        id;
      t.axios.get(url).then((res) => {
        t.status = res.data.focus;
        t.status = res.data.focus == 1 ? "已收藏" : "收藏商品";
      });
    },
    shouce() {
      let t = this;
      let id = localStorage.getItem("uid");
      let formData = new FormData();
      formData.append("token", id);
      formData.append("goods_id", this.$route.params.id);
      if (t.status == "收藏商品") {
        var url = window.config.api_url + "/user/goods/focus";
        t.axios.post(url, formData).then((res) => {
          t.$code(res.data.status);
          if (res.data.status == 0) {
            t.open2("成功");
            // 接口调用成功
            this.$router.go(0);
          }
        });
        this.status = "已收藏";
      } else {
        var url1 = window.config.api_url + "/user/goods/unfocus";
        t.axios.post(url1, formData).then((res) => {
          t.$code(res.data.status);
          if (res.data.status == 0) {
            // 接口调用成功
            t.open2("成功");
            // this.status = '收藏商品'// 要改成的值
            this.$router.go(0);
          }
        });
        this.status = "收藏商品";
      }
    },
    dp_inform() {
      let t = this;
      let url =
        window.config.api_url + "/college/shop/info?id=" + t.list.shop_id;
      t.axios.get(url).then((res) => {
        t.inform = res.data;
        t.inform_uid = res.data.uid;
        t.inform_name = res.data.name;
        t.data_info = res.data;
        CodeToText[res.data.auth_info.province] === undefined
          ? (t.sheng = res.data.auth_info.province_name)
          : (t.sheng = CodeToText[res.data.auth_info.province]);
        CodeToText[res.data.auth_info.city] === undefined
          ? (t.shi = res.data.auth_info.city_name)
          : (t.shi = CodeToText[res.data.auth_info.city]);
        CodeToText[res.data.auth_info.area] === undefined
          ? (t.qv = res.data.auth_info.area_name)
          : (t.qv = CodeToText[res.data.auth_info.area]);
      });
    },
    goumai_sj(e) {
      let t = this;
      let list_vu = [];
      t.list_guige.forEach(function (item) {
        if (item.sum !== 0) {
          list_vu.push({
            estimate: item.estimate,
            goods_id: t.list.id,
            id: item.id,
            price: item.price,
            cash: t.list.cash,
            specification: t.list.title,
            sum: item.sum,
          });
        }
      });
      if (list_vu == "") {
        return t.$message.error("请至少选择一个商品规格");
      }
      t.$store.commit("saveDbSource", list_vu);
      if (t.list.api_edition === "2202") {
        window.location = "#/index_new/" + e;
      } else {
        window.location = "#/purchase/" + e;
      }
    },
    chat_room() {
      if (this.data_uid != "") {
        window.location.href =
          "#/chat_new/" + this.data_uid + "?uid=" + this.inform_uid;
      } else {
        window.location.href = "/user.html";
      }
    },
    list_data() {
      let t = this;
      let url = window.config.api_url + "/college/goods/" + t.$route.params.id;
      t.axios.get(url).then((res) => {
        t.list = res.data;
        t.list_uid = res.data.uid;
        t.shop_id = res.data.shop_id;
        t.list_flowchart = res.data.flowchart_data;
        t.scene_li = [];
        t.list.aac_job.forEach((item) => {
          t.scene_li.push(item.scene);
        });
        t.aac_job = res.data.aac_job;
        console.log(t.aac_job, "image.png");
        // res.data.specification.forEach(function (item) {
        t.list_guige.push({
          estimate: "",
          goods_id: t.list.id,
          id: "",
          price: "",
          cash: t.list.cash,
          specification: t.list.title,
          sum: "",
          // })
        });
        t.dp_inform();
        t.shangpin_data();
        t.fuwu_data();
      });
    },
    fujiaxz(e) {
      this.$router.push(this.url + "/storage/" + e);
    },
    handleChange2(e) {
      this.$store.commit("savePath", e);
    },
    get_uidlist() {
      let t = this;
      let aid = localStorage.getItem("uid");
      let url = window.config.api_url + "/user/shop/info?token=" + aid;//返回101
      t.axios.get(url).then((res) => {
        t.data_list = res.data;
        t.data_uid = res.data.shop_info.uid;
      });
    },
    dianji() {
      this.zz = 2;
    },
    dianji1() {
      this.zz = 1;
    },
    shangpin_data(){
      var t = this
      var url = window.config.api_url+'/college/shop/goods/cate?shop_id='+t.list.shop_id;
      t.axios.get(url).then(res=>{
        if (res.data.status){
          t.$code(res.data.status)
        }
        if (res.data.status==401){
          t.opent()
        }
        t.shangpin_list = res.data
          console.log("sangpin_list",res.data)
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      })
    },
    fuwu_data(){
      var t = this
      var url = window.config.api_url+'/college/shop/fuwu/cate?shop_id='+t.list.shop_id;
      t.axios.get(url).then(res=>{
        if (res.data.status){
          t.$code(res.data.status)
        }
        if (res.data.status==401){
          t.opent()
        }
        t.fuwu_list = res.data
          console.log("fuwu_list",res.data)
        // t.zongshu = res.data.goods_list.total
        // t.yemashu =  res.data.goods_list.last_page
        // console.log(res)
      })
    },
  },
  created() {
    this.init();

  },


};
</script>
<style lang="less">
.home_shop_xiang_peizhi_qiangzhi_elementui_leixing {
  .el-tabs__nav-wrap::after {
    background-color: #ffffff !important;
    width: 0;
  }
}
</style>


<style>
.julizhi {
  margin-top: 10px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__active-bar {
  background-color: #4e6ef2;
  left: 1px;
  width: 58px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-left:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-icon-arrow-right:before {
  display: none !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
  /*padding: 0 14px!important;*/
  /*font-size: 14px!important;*/
  line-height: 47px;
  font-size: 18px !important;
  padding-right: 83px !important;
  /*margin-right: 88px;*/
  /*padding: 0 44px!important;*/
  height: 45px;
  font-weight: bold;
  color: #333333;
}

.el-tabs__nav-scroll {
  margin-left: 45px;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__item {
  padding: 0 !important;
  width: 120px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .el-tab-pane {
  margin-left: 35px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom[data-v-7edfb125] {
  left: -10px;
}

@media screen and (min-width: 995px) and (max-width: 1500px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 25px !important;
    /*margin-right: 26px;*/
    font-size: 15px !important;
    /*padding-left: 25px;*/
    height: 45px;
    font-weight: bold;
    color: #333333;
  }
}

@media screen and (min-width: 750px) and (max-width: 995px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 24px !important;
    font-size: 16px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }
}

@media screen and (max-width: 750px) {
  .ciyemian_yibei_qiangzhi_buxudong .contain .shop {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .contain {
    width: 100% !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-num {
    margin-left: 55px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .moneys-nums {
    margin-left: 45px !important;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 .el-tabs__item {
    padding-right: 4px !important;
    font-size: 13px !important;
    height: 45px;
    font-weight: bold;
    color: #333333;
  }

  .ciyemian_yibei_qiangzhi_buxudong .xq_neirong2 {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding-left: 0px !important;
    margin-top: 25px;
  }

  .ciyemian_yibei_qiangzhi_buxudong .jibuqi {
    margin-left: 50px !important;
  }
}

.ciyemian_yibei_qiangzhi_buxudong .el-tabs__header {
  margin-bottom: 0px !important;
}

.ciyemian_yibei_qiangzhi_buxudong .xq_neirong2_bottom div {
  margin-left: 23px;
  margin-right: 40px !important;
  float: left;
  font-size: 14px;
  color: #666666;
  line-height: 60px;
}

.jibuqi {
  margin-left: 68px;
}

.jibuqi .el-input__inner {
  padding: 0;
  border: 0px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-minus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d8";
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-icon-plus:before {
  font-size: 14px !important;
  color: #ffffff;
  font-weight: bold;
  content: "\e6d9";
}

.jibuqi .el-input-number--mini {
  width: 98px;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__increase {
  width: 27px;
  background: #4e6ef2 !important;
}

.ciyemian_yibei_qiangzhi_buxudong .jibuqi .el-input-number__decrease {
  width: 27px;
  background: #4e6ef2 !important;
}

.imgsize p img {
  max-width: 100%;
}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

@head_text: Source Han Sans CN;

@import "../../../assets/css/home";
@import "../../../assets/css/home_details";
@import "../../../assets/css/head_yangshi";

//@import "../../../assets/css/goods_detailed";
.flextext {
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}

.btncss {
  position: absolute;
}

.el-icon-service {
  color: white;
  width: 18px;
  height: 18px;
  margin-left: 25px;
  margin-top: 18px;
}

.kefuzhongxin {
  font-family: Source Han Sans CN;
  font-size: 18px;
  color: white;
  font-weight: bold;
}

.center_title {
  width: 272px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  margin-left: 25px;
  margin-top: 19px;
}

.center_mintitle {
  width: 272px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #333333;
  margin-left: 25px;
  margin-top: 15px;
}

.center_aa {
  width: 272px;
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #333333;
  margin-left: 25px;
}

.center_button {
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #333333;
}

.image_css {
  width: 940px;
  height: 624px;
  margin-top: 23px;
  margin-left: 20px;
}

.image_css1 {
  border-radius: 20px;
  width: 900px;
  height: 624px;
}

.min-title-content {
  background-color: white;
  height: 38px;
  width: 955px;
  margin-top: 38px;
}

.mimi_title {
  height: 38px;
  width: 58px;
  background-image: linear-gradient(to right, #4e6ef2, white);
}

.col_content {
  margin-top: 20px;
  margin-left: 25px;
  background-color: white;
  width: 220px;
  min-height: 470px;
  height: 100%;
}

.col_content1 {
  background-color: white;
  width: 943px;
  height: 243px;
  margin-left: 25px;
  margin-top: 20px;
}

.image_min {
  width: 220px;
  height: 198px;
  background-color: black;
}

.image_min1 {
  background-color: #0c73db;
  width: 243px;
  height: 243px;
  margin-left: 8px;
}

.img_title {
  color: #4e6ef2;
  font-size: 18px;
  width: 180px;
  font-family: Source Han Sans CN;
  margin-left: 21px;
  margin-top: 13px;
}

.img_title1 {
  position: absolute;
  margin: 0px 517px 194px 65px;
  color: #4e6ef2;
  width: 500px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #4e6ef2;
  line-height: 100px;
}

.img_desc1 {
  position: absolute;
  width: 500px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin: 71px 517px 194px 65px;
}

.img_price1 {
  position: absolute;
  width: 73px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bolder;
  color: red;
  line-height: 21px;
  margin: 157px 517px 194px 65px;
}

.kehu_xuyao {
  width: 262px;
  height: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  margin: 22px 0px 14px 39px;
}

.kehu_content {
  border: 2px solid #d9d9d9;
  width: 857px;
  height: 100%;
  min-height: 80px;
  margin-left: 39px;
}

.top_desc {
  margin-left: 21px;
  width: 940px;
  height: 100%;
  margin-top: 20px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  color: #666666;
}

.gl_more {
  float: left;
  margin-top: 20px;
  margin-left: 15px;
  color: rgb(152, 153, 156);
  cursor: pointer;
}

.gl_more1 {
  margin: 10px;
}

.gl_ycx {
  color: #1c1c1c;
  font-weight: bolder;
  margin-right: 10px;
  font-size: 15px;
}

.more-icon {
  margin-left: 830px;
  margin-top: -50px;
  color: rgb(152, 153, 156);
  cursor: pointer;
}

.flex {
  display: flex;

  //  justify-content:space-around;
  .yixiaoxing {
    height: 25px;
    width: 25px;
    margin-left: 50px;
    // background-color: #ccc;
    display: inline-block;

    .image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>